/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ClientBookingPreviewPaymentTypes = {
    paymentTypes: Array<'online' | 'cash' | 'invoice'>;
    onlinePaymentMethods: Array<'card' | 'sepa' | 'paypal' | 'klarna' | 'bank_transfer' | 'apple_pay' | 'google_pay'>;
    onlineProviderType?: ClientBookingPreviewPaymentTypes.onlineProviderType | null;
    stripeConnectedAccountId?: string | null;
};
export namespace ClientBookingPreviewPaymentTypes {
    export enum onlineProviderType {
        PAYPAL = 'paypal',
        STRIPE = 'stripe',
    }
}

